module.exports = __webpack_public_path__ + "img/DS8208x12SD_Large.1a56c113.jpg";